import React from 'react'
import OrangeSalonAnalysis from '../components/dashboard/OrangeSalonAnalysis'

const OrangeSalonAnalysisPage = () => <OrangeSalonAnalysis />

export default OrangeSalonAnalysisPage
